import React from 'react';

var _path;

var SvgChannelsMajor = function SvgChannelsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.284 14.546A2.975 2.975 0 0 1 17 14c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3a2.94 2.94 0 0 1 .129-.822l-1.575-1.125A3.964 3.964 0 0 1 10 16a3.964 3.964 0 0 1-2.554-.947l-1.575 1.125c.076.262.129.535.129.822 0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3c.615 0 1.214.191 1.716.546l1.56-1.114A3.97 3.97 0 0 1 6 12c0-1.858 1.28-3.411 3-3.858V5.815A2.993 2.993 0 0 1 7 3c0-1.654 1.346-3 3-3s3 1.346 3 3a2.996 2.996 0 0 1-2 2.816v2.326c1.72.447 3 2 3 3.858-.003.49-.096.976-.276 1.432l1.56 1.114zm1.037 3.146A1 1 0 0 0 17 18a1 1 0 0 0 0-2 1 1 0 0 0-.679 1.692zm-14 0A1 1 0 0 0 3 18a1 1 0 0 0 0-2 1 1 0 0 0-.679 1.692zM11 3c0-.551-.449-1-1-1-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1z"
  })));
};

export { SvgChannelsMajor as S };
